import React from "react";
import { Button, Card, Form, Input } from "antd";
import { useAddResource } from "../queries/resource";
import { formValues } from "../types/resource";
import { useTitle } from "../hooks/useTitle";
import { useTranslation } from "react-i18next";
import { BackButton } from "../components/BackButton";

const AddResourcePage = () => {
  const { t } = useTranslation();

  useTitle(t("page-title.add-resource"));
  const [form] = Form.useForm();
  const { mutate: addResource, isPending } = useAddResource();

  const onFinish = (values: formValues) => {
    addResource(values);
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: 500,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        marginTop: "2.5rem",
      }}
    >
      <Card title={t("pages.new-resource.new-resource")} style={{ width: 500 }}>
        <Form layout="vertical" onFinish={onFinish} form={form}>
          <Form.Item
            label={t("pages.new-resource.name")}
            name="name"
            rules={[
              {
                required: true,
                message:
                  t("pages.new-resource.name-required") || "Name is required",
              },
            ]}
          >
            <Input
              placeholder={t("pages.new-resource.name") || undefined}
              maxLength={1000}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              style={{ float: "right" }}
              type="primary"
              htmlType="submit"
              loading={isPending}
            >
              {t("pages.new-resource.create")}
            </Button>
          </Form.Item>
        </Form>
      </Card>
      <BackButton />
    </div>
  );
};

export default AddResourcePage;
